import React from "react";

import ServicesSlider from "./servicesSlides";

import { NavLink } from "react-router-dom";

import ecoBackground from "../images/eco-background.jpg";
import plant from "../images/plant.jpg";
import plantSix from "../images/plant-6.jpg";
import waterfallFour from "../images/waterfall-4.jpg";
import picTwo from "../images/pic-2.jpg";
import picOne from "../images/pic-1.jpg";
import pic from "../images/pic.jpg";

function Home() {
  return (
    <div>
      <section className="eco-background-section position-relative text-white d-flex align-items-center justify-content-center text-center">
        <div
          className="eco-background position-absolute w-100 h-100 top-0 start-0"
          style={{
            background: `url(${ecoBackground}) no-repeat center center`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            opacity: "0.65",
            zIndex: 1,
          }}
        ></div>

        <div className="hero-content position-relative z-2 px-4">
          <h1
            data-aos="fade-up"
            data-aos-duration="10000"
            className="display-4 fw-bold mb-3"
          >
            Small Choices, Big Change
          </h1>
          <p
            data-aos="fade-up"
            data-aos-delay="200"
            data-aos-duration="10000"
            className="lead mb-4"
          >
            At <strong>Ecosphere</strong>, we empower greener living — one
            mindful decision at a time. Let’s restore balance and grow a
            thriving planet, together.
          </p>
          <div className="hero-buttons d-flex gap-3 justify-content-center flex-wrap">
            <NavLink
              data-aos="fade-up"
              data-aos-delay="300"
              data-aos-duration="10000"
              className="btn btn-light rounded-pill px-4 py-2 fw-semibold"
              to="/about"
            >
              Learn More
            </NavLink>

            <a
              data-aos="fade-up"
              data-aos-delay="300"
              data-aos-duration="10000"
              href="#startJourney"
              className="btn btn-outline-light rounded-pill px-4 py-2 fw-semibold"
            >
              Start Your Eco Journey
            </a>
          </div>
        </div>
      </section>

      <section className="hero-section" id="startJourney">
        <div className="container">
          <div className="row align-items-center">
            <div className="content-col col-12 col-md-6 col-lg-6 mb-4">
              <div
                data-aos="fade-up"
                data-aos-delay="300"
                data-aos-duration="10000"
                className="content"
              >
                <p className="highlighted-text">
                  Nurture a Safe{" "}
                  <span
                    className="icon-wrapper"
                    aria-label="leaf icon"
                    role="img"
                  >
                    <svg
                      fill="#1d4130"
                      version="1.1"
                      id="Capa_1"
                      width="80px"
                      height="65px"
                      viewBox="0 0 105.296 105.296"
                    >
                      <g>
                        <g>
                          <path d="M104.054,25.24c-0.784-0.318-2.036-0.979-3.528-1.377c-1.492-0.421-3.508-1.121-5.564-1.297c-2.077-0.217-4.425-0.281-6.991-0.157c-2.505,0.204-5.048,0.736-7.775,1.441c-2.724,0.703-5.216,1.873-7.878,3.153c-2.598,1.324-4.966,2.976-7.337,4.775c-2.241,1.858-4.367,3.915-6.311,6.102c-1.813,2.247-3.615,4.559-5.003,7.026c-1.431,2.45-2.665,4.973-3.558,7.553c-1.91,5.108-2.671,10.364-2.751,15.045c0.007,2.375,0.147,4.579,0.441,6.604c0.257,2.013,0.761,3.871,1.15,5.373c0.157,0.705,0.378,1.379,0.596,1.975c0.383-0.804,0.799-1.652,1.263-2.58c2.305-4.572,5.665-10.526,9.594-16.102c1.957-2.792,4.104-5.447,6.197-7.847c1.109-1.153,2.181-2.262,3.193-3.314c1.088-0.977,2.115-1.903,3.056-2.755c1.021-0.767,1.951-1.465,2.779-2.087c0.794-0.659,1.625-1.042,2.248-1.438c1.27-0.752,1.995-1.181,1.995-1.181s-0.691,0.488-1.896,1.332c-0.586,0.448-1.373,0.883-2.112,1.598c-0.766,0.676-1.629,1.437-2.573,2.267c-0.865,0.916-1.8,1.899-2.789,2.943c-0.91,1.109-1.872,2.279-2.864,3.491c-1.872,2.522-3.754,5.273-5.448,8.155c-3.411,5.738-6.223,11.807-8.115,16.426c-0.532,1.301-0.98,2.464-1.365,3.491c0.81-0.216,1.839-0.445,2.949-0.855c1.408-0.489,3.226-0.993,4.988-1.712c1.804-0.69,3.727-1.505,5.667-2.433c1.971-0.914,3.891-1.988,5.858-3.118c1.965-1.125,3.826-2.412,5.675-3.736c1.796-1.376,3.579-2.766,5.197-4.305c1.599-1.582,3.214-3.066,4.61-4.781c2.871-3.289,5.317-6.807,7.31-10.52c1.037-1.749,1.899-3.785,2.744-5.625c0.855-1.826,1.581-3.852,2.304-5.71c0.729-1.824,1.403-3.672,1.998-5.472c0.647-1.854,1.212-3.47,1.681-4.798c0.541-1.321,0.879-2.702,1.184-3.515c0.281-0.918,0.425-1.403,0.425-1.403S104.862,25.608,104.054,25.24z" />
                          <path d="M40.429,66.34c-2.792-1.958-5.444-4.106-7.845-6.201c-1.15-1.102-2.26-2.177-3.314-3.189c-0.979-1.088-1.899-2.115-2.758-3.056c-0.765-1.017-1.461-1.955-2.086-2.779c-0.659-0.795-1.037-1.625-1.436-2.248c-0.754-1.267-1.182-1.995-1.182-1.995s0.488,0.691,1.336,1.896c0.441,0.585,0.879,1.371,1.598,2.11c0.676,0.769,1.436,1.632,2.267,2.576c0.914,0.862,1.899,1.8,2.943,2.785c1.107,0.91,2.281,1.872,3.491,2.864c2.519,1.865,5.273,3.754,8.153,5.448c1.192,0.712,2.4,1.338,3.604,1.981c0.398-6.44,1.72-12.806,3.699-18.604c-1.134-1.466-2.284-2.909-3.549-4.23c-1.581-1.602-3.059-3.217-4.78-4.611c-3.291-2.871-6.805-5.316-10.517-7.312c-1.749-1.037-3.788-1.899-5.628-2.743c-1.822-0.855-3.846-1.584-5.705-2.303c-1.826-0.726-3.672-1.398-5.474-1.993c-1.853-0.652-3.465-1.217-4.798-1.686c-1.321-0.538-2.705-0.879-3.515-1.184c-0.914-0.277-1.401-0.424-1.401-0.424s-0.271,0.441-0.642,1.248c-0.315,0.782-0.977,2.036-1.377,3.528c-0.419,1.487-1.121,3.504-1.292,5.561c-0.221,2.079-0.284,4.43-0.157,6.995c0.198,2.503,0.729,5.042,1.436,7.773c0.708,2.722,1.875,5.217,3.153,7.881c1.326,2.591,2.976,4.959,4.781,7.334c1.857,2.245,3.914,4.37,6.1,6.317c2.243,1.807,4.56,3.61,7.031,5.003c2.445,1.431,4.969,2.666,7.548,3.556c5.106,1.913,10.362,2.673,15.047,2.755c0.2,0,0.371-0.021,0.561-0.027c-0.501-3.282-0.683-6.632-0.621-9.996C43.545,68.393,41.983,67.435,40.429,66.34z" />
                        </g>
                      </g>
                    </svg>
                  </span>
                </p>
                <p className="subtitle">And Sustainable Planet</p>
                <p className="description">
                  Protecting our Earth means creating conditions where nature
                  can thrive and future generations can live in harmony with it.
                  By promoting clean energy, reducing waste, and preserving
                  natural ecosystems, we build a balanced and resilient
                  environment—one that supports all life and restores the
                  planet’s natural rhythms.
                </p>
                <div className="buttons">
                  <NavLink to="/getaquote" className="btn btn-primary">
                    Get a Quote
                  </NavLink>
                  <NavLink to="/contact" className="btn btn-secondary">
                    Contact Us
                  </NavLink>
                </div>
              </div>
            </div>
            <div
              data-aos="fade-up"
              data-aos-delay="100"
              data-aos-duration="1500"
              className="col-12 col-md-6 col-lg-6 h-100"
            >
              <div className="card">
                <img
                  src={plant}
                  alt="Green plant representing sustainability"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="more-info position-relative text-light py-5">
        <div
          className="background-image position-absolute top-0 start-0 w-100 h-100"
          style={{
            backgroundImage: `url(${waterfallFour})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            filter: "brightness(0.25)",

            zIndex: 0,
          }}
        ></div>

        <div className="container position-relative" style={{ zIndex: 1 }}>
          <div className="row align-items-center">
            <div
              data-aos="fade-up"
              data-aos-delay="100"
              data-aos-duration="1500"
              className="col-12 col-md-6 mb-4 mb-md-0"
            >
              <div className="card border-3 rounded-4 overflow-hidden">
                <img
                  src={waterfallFour}
                  alt="waterfall"
                  className="img-fluid w-100 h-100 object-fit-cover"
                />
              </div>
            </div>

            <div
              data-aos="fade-up"
              data-aos-delay="300"
              data-aos-duration="1500"
              className="col-12 col-md-6"
            >
              <div className="content">
                <p className="h3 fw-bold mb-4 text-uppercase">
                  Lush, Resilient & Ever-Alive Forests
                </p>

                <div className="d-flex gap-3 mb-4">
                  <span>
                    <svg
                      fill="rgb(246, 252, 235)"
                      width="28"
                      height="28"
                      viewBox="0 0 14 14"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="m 8.666766,10.442068 c -0.72412,-0.033 -2.32929,-0.2387 -3.85785,-0.4953003 -0.21892,-0.037 -0.45185,-0.072 -0.51763,-0.079 -0.19648,-0.02 -0.31662,0.01 -0.46822,0.1034 -0.0373,0.024 -0.0711,0.043 -0.0751,0.043 -0.004,0 -0.004,-0.013 2.8e-4,-0.03 0.01,-0.038 0.0411,-0.3872 0.11149,-1.2316 0.0654,-0.7846 0.17423,-2.0453 0.18536,-2.1468 0.0123,-0.1123 -0.0233,-0.1036 0.8123,-0.1985 0.74532,-0.085 0.90022,-0.086 1.45156,-0.018 0.30944,0.039 0.76595,0.139 1.50663,0.3314 1.09115,0.2835 1.69183,0.4629 1.80068,0.5378 0.15767,0.1085 0.24804,0.3277 0.2172,0.527 -0.0637,0.4115 -0.56984,0.6738 -1.20187,0.6229 -0.28578,-0.023 -0.58009,-0.1001 -1.36713,-0.3583 -0.25597,-0.084 -0.52051,-0.1696 -0.58787,-0.1901 -0.14649,-0.045 -0.33723,-0.091 -0.34471,-0.083 -0.0111,0.011 0.0731,0.07 0.26379,0.1844 0.64023,0.3845 1.1165,0.5824 1.63019,0.6775 0.16517,0.031 0.62685,0.031 0.76187,0 0.23566,-0.053 0.56806,-0.2196 0.74491,-0.3742 0.10758,-0.094 0.17361,-0.1376 0.23616,-0.1556 0.0349,-0.01 0.19854,-0.041 0.36357,-0.068 0.61866,-0.1024 0.90011,-0.1814 1.38392,-0.3882 0.34637,-0.1481 0.44465,-0.1774 0.61848,-0.1841 0.12806,-0.01 0.15704,0 0.22519,0.021 0.106,0.036 0.18971,0.092 0.27421,0.1834 0.12287,0.1329 0.1767,0.2779 0.16407,0.4418 -0.0154,0.2002 -0.0982,0.3584 -0.28549,0.5457 -0.26776,0.2677 -0.76032,0.5668 -1.71291,1.0401 -0.66109,0.3285003 -1.13807,0.5363003 -1.57185,0.6849003 l -0.20016,0.069 -0.17338,0 c -0.0953,-10e-4 -0.26982,-0.01 -0.3877,-0.011 z m -7.66671,-2.1115003 0,-2.0024 1.4023,0 c 1.25428,0 1.4023,0 1.4023,0.019 0,0.01 -0.006,0.07 -0.0124,0.1316 -0.0164,0.1499 -0.19223,2.2077 -0.26444,3.095 -0.0405,0.4978003 -0.062,0.7093003 -0.0735,0.7216003 -0.0256,0.028 -0.35614,0.036 -1.45928,0.037 l -0.99507995,9e-4 0,-2.0024003 z m 9.2679,-0.6189 c -0.0589,-0.047 -0.10703,-0.089 -0.10703,-0.093 0,0 0.0357,-0.067 0.0794,-0.1402 0.23016,-0.3878 0.33107,-0.6859 0.35636,-1.0527 0.0174,-0.2532 -0.0544,-0.62 -0.17484,-0.8922 -0.0223,-0.05 -0.15264,-0.2638 -0.25069,-0.4103 -0.004,-0.01 -0.059,0.036 -0.12125,0.094 -0.13457,0.1267 -0.24034,0.1843 -0.38541,0.2102 -0.50626,0.09 -1.08204,-0.1802 -1.7085,-0.8023 -0.14321,-0.1423 -0.4329,-0.4618 -0.5247,-0.5788 -0.0155,-0.02 -0.003,-0.028 0.15921,-0.1057 0.27573,-0.1318 0.67244,-0.2766 0.90971,-0.3321 0.26815,-0.063 0.66853,-0.082 0.89674,-0.043 0.45621,0.078 0.77561,0.3583 0.86918,0.7618 0.0105,0.045 0.0234,0.1652 0.0288,0.2666 0.0115,0.218 0.0106,0.2157 0.18133,0.4593 0.0637,0.091 0.13194,0.197 0.15155,0.2358 0.0196,0.039 0.042,0.07 0.0498,0.07 0.008,0 0.0835,-0.071 0.16822,-0.1568 0.20034,-0.2038 0.30907,-0.2745 0.54748,-0.3561 0.25462,-0.087 0.53953,-0.1352 0.8595,-0.1448 l 0.23642,-0.01 -0.006,0.029 c -0.003,0.016 -0.0154,0.076 -0.0265,0.1334 -0.0861,0.4451 -0.35554,1.0489 -0.58114,1.3024 -0.0682,0.077 -0.19287,0.1706 -0.28679,0.2163 -0.20274,0.099 -0.38844,0.098 -0.58724,0 -0.0809,-0.041 -0.0926,-0.036 -0.0932,0.039 -5.3e-4,0.071 -0.0471,0.3513 -0.0802,0.4821 -0.0366,0.1446 -0.0807,0.2759 -0.12929,0.3841 -0.0662,0.1476 -0.29116,0.5178 -0.31464,0.5178 -0.005,0 -0.0571,-0.039 -0.11597,-0.086 z m 0.82917,-1.6648 c 0.0214,-0.013 0.0771,-0.072 0.12383,-0.1316 0.17257,-0.2187 0.39547,-0.4293 0.60207,-0.5687 0.13231,-0.089 0.19946,-0.1536 0.19946,-0.1912 0,-0.043 -0.0792,-0.1168 -0.11459,-0.1061 -0.0396,0.012 -0.21156,0.1285 -0.36594,0.2478 -0.29668,0.2294 -0.58423,0.5637 -0.58485,0.6799 -1.4e-4,0.025 0.0632,0.094 0.0863,0.094 0.008,0 0.0323,-0.011 0.0537,-0.024 z m -1.28373,-1.3447 c 0.0211,-0.014 0.0657,-0.092 0.0658,-0.1156 9e-5,-0.031 -0.0656,-0.076 -0.20915,-0.1429 -0.32707,-0.1534 -0.73154,-0.2582 -1.14254,-0.296 -0.21866,-0.02 -0.26734,-0.01 -0.26734,0.078 0,0.092 0.007,0.095 0.327,0.136 0.3836,0.049 0.67444,0.1301 1.03488,0.2877 0.14218,0.062 0.16633,0.069 0.19135,0.052 z" />
                    </svg>
                  </span>
                  <div className="flex-grow-1">
                    <p className="fw-semibold mb-1">
                      Green Growth & Local Livelihoods
                    </p>
                    <p className="mb-0 text-wrap small">
                      Forests are more than scenery—they're sustainable
                      powerhouses that drive eco-tourism, support local
                      businesses, and promote ethical harvesting. With every
                      protected tree, we grow futures, jobs, and harmony with
                      nature.
                    </p>
                  </div>
                </div>

                <div className="d-flex gap-3 mb-4">
                  <span>
                    <svg
                      fill="rgb(246, 252, 235)"
                      height="25px"
                      width="25px"
                      version="1.1"
                      id="Layer_1"
                      viewBox="0 0 512 512"
                    >
                      <g>
                        <g>
                          <path d="M270.456,80.696c-6.402-11.112-22.511-11.112-28.914,0C148.57,241.698,139.13,248.841,139.13,289.391c0,64.441,52.424,116.87,116.87,116.87s116.87-52.429,116.87-116.87C372.87,248.809,363.409,241.648,270.456,80.696z M256,339.478c-38.598,0-62.539-41.998-43.445-75.044c4.619-7.984,14.848-10.695,22.815-6.093c7.978,4.615,10.706,14.831,6.098,22.81c-6.252,10.778,1.559,24.936,14.532,24.936c9.217,0,16.696,7.473,16.696,16.696C272.696,332.005,265.217,339.478,256,339.478z" />
                        </g>
                      </g>
                      <g>
                        <g>
                          <path d="M501.859,184.549c-2.587-8.853-11.87-13.913-20.696-11.364c-8.859,2.581-13.945,11.848-11.37,20.701c5.848,20.086,8.815,40.983,8.815,62.113c0,122.744-99.859,222.609-222.609,222.609c-62.856,0-122.063-26.614-163.981-72.353h32.775c9.217,0,16.696-7.473,16.696-16.696c0-9.223-7.479-16.584-16.696-16.584H58.011c-10.011,0-18.918,9.167-16.696,20.132v63.235c0,9.223,7.479,16.696,16.696,16.696s16.696-7.473,16.696-16.696v-19.771C122.348,484.43,187.301,512,256,512c141.163,0,256-114.843,256-256C512,231.712,508.587,207.668,501.859,184.549z" />
                        </g>
                      </g>
                      <g>
                        <g>
                          <path d="M456.348,38.957c-9.217,0-16.696,7.473-16.696,16.696v22.214C391.811,28.514,325.865,0,256,0C114.837,0,0,114.843,0,256c0,24.293,3.413,48.332,10.141,71.445c2.608,8.926,11.926,13.934,20.696,11.359c8.859-2.576,13.945-11.843,11.37-20.696c-5.848-20.08-8.815-40.978-8.815-62.108C33.391,133.256,133.25,33.391,256,33.391c62.869,0,122.065,26.606,163.976,72.348h-30.411c-9.217,0-16.696,7.473-16.696,16.696c0,9.223,7.479,16.696,16.696,16.696h64.885c0.023,0,0.048,0,0.069,0c11.963,0,18.524-7.77,18.524-16.696V55.652C473.043,46.43,465.565,38.957,456.348,38.957z" />
                        </g>
                      </g>
                    </svg>
                  </span>
                  <div className="flex-grow-1">
                    <p className="fw-semibold mb-1">
                      Clean Air, Fresh Water, Living Earth
                    </p>
                    <p className="mb-0 text-wrap small">
                      Acting as Earth's natural filters, forests absorb carbon,
                      purify water, and regulate rainfall. They shield us from
                      pollution, preserve biodiversity, and stabilize entire
                      ecosystems—making our world livable and thriving.
                    </p>
                  </div>
                </div>

                <NavLink
                  to="/about"
                  className="btn btn-outline-light rounded-pill px-4 py-2 shadow-sm"
                >
                  More About Us
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        data-aos="fade-up"
        data-aos-delay="100"
        data-aos-duration="1500"
        className="services"
      >
        <div className="container">
          <p className="main-heading mt-4">Our Services</p>
          <p className="sub-text">
            From supporting sustainable forestry and reducing paper waste to
            using low-impact materials and encouraging responsible consumption,
            every aspect of our service is designed with the planet in mind.
          </p>

          <div data-aos="fade-up" data-aos-delay="200" data-aos-duration="1500">
            <ServicesSlider />
          </div>
        </div>
      </section>

      <section className="closing">
        <div className="container">
          <p
            data-aos="fade-up"
            data-aos-delay="100"
            data-aos-duration="1500"
            className="main-heading mt-5"
          >
            {" "}
            Creating Lasting Change{" "}
          </p>
          <p className="main-heading"> Through Environmental Responsibility</p>
          <p
            data-aos="fade-up"
            data-aos-delay="200"
            data-aos-duration="1500"
            className="sub-text"
          >
            We commit to meaningful action that reduces harm, restores
            ecosystems, and inspires conscious choices—paving the way for a
            healthier planet and future generations.
          </p>

          <div
            data-aos="fade-up"
            data-aos-delay="300"
            data-aos-duration="1500"
            className="row align-items-stretch mb-5"
          >
            <div className="col-3 col-md-3 col-lg-3 d-flex flex-column">
              <div className="card">
                <img src={picTwo} alt="pic-2.jpg" />
              </div>
            </div>
            <div className="col-3 col-md-3 col-lg-3 d-flex flex-column">
              <p className="text text-one">
                <span>
                  <svg
                    width="25px"
                    height="25px"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.5 15.25C10.307 15.2353 10.1276 15.1455 9.99998 15L6.99998 12C6.93314 11.8601 6.91133 11.7029 6.93756 11.55C6.96379 11.3971 7.03676 11.2562 7.14643 11.1465C7.2561 11.0368 7.39707 10.9638 7.54993 10.9376C7.70279 10.9114 7.86003 10.9332 7.99998 11L10.47 13.47L19 5.00004C19.1399 4.9332 19.2972 4.91139 19.45 4.93762C19.6029 4.96385 19.7439 5.03682 19.8535 5.14649C19.9632 5.25616 20.0362 5.39713 20.0624 5.54999C20.0886 5.70286 20.0668 5.86009 20 6.00004L11 15C10.8724 15.1455 10.6929 15.2353 10.5 15.25Z"
                      fill="#A8C686"
                    />
                    <path
                      d="M12 21C10.3915 20.9974 8.813 20.5638 7.42891 19.7443C6.04481 18.9247 4.90566 17.7492 4.12999 16.34C3.54037 15.29 3.17596 14.1287 3.05999 12.93C2.87697 11.1721 3.2156 9.39921 4.03363 7.83249C4.85167 6.26578 6.1129 4.9746 7.65999 4.12003C8.71001 3.53041 9.87134 3.166 11.07 3.05003C12.2641 2.92157 13.4719 3.03725 14.62 3.39003C14.7224 3.4105 14.8195 3.45215 14.9049 3.51232C14.9903 3.57248 15.0622 3.64983 15.116 3.73941C15.1698 3.82898 15.2043 3.92881 15.2173 4.03249C15.2302 4.13616 15.2214 4.2414 15.1913 4.34146C15.1612 4.44152 15.1105 4.53419 15.0425 4.61352C14.9745 4.69286 14.8907 4.75712 14.7965 4.80217C14.7022 4.84723 14.5995 4.87209 14.4951 4.87516C14.3907 4.87824 14.2867 4.85946 14.19 4.82003C13.2186 4.52795 12.1987 4.43275 11.19 4.54003C10.193 4.64212 9.22694 4.94485 8.34999 5.43003C7.50512 5.89613 6.75813 6.52088 6.14999 7.27003C5.52385 8.03319 5.05628 8.91361 4.77467 9.85974C4.49307 10.8059 4.40308 11.7987 4.50999 12.78C4.61208 13.777 4.91482 14.7431 5.39999 15.62C5.86609 16.4649 6.49084 17.2119 7.23999 17.82C8.00315 18.4462 8.88357 18.9137 9.8297 19.1953C10.7758 19.4769 11.7686 19.5669 12.75 19.46C13.747 19.3579 14.713 19.0552 15.59 18.57C16.4349 18.1039 17.1818 17.4792 17.79 16.73C18.4161 15.9669 18.8837 15.0864 19.1653 14.1403C19.4469 13.1942 19.5369 12.2014 19.43 11.22C19.4201 11.1169 19.4307 11.0129 19.461 10.9139C19.4914 10.8149 19.5409 10.7228 19.6069 10.643C19.6728 10.5631 19.7538 10.497 19.8453 10.4485C19.9368 10.3999 20.0369 10.3699 20.14 10.36C20.2431 10.3502 20.3471 10.3607 20.4461 10.3911C20.5451 10.4214 20.6372 10.471 20.717 10.5369C20.7969 10.6028 20.863 10.6839 20.9115 10.7753C20.9601 10.8668 20.9901 10.9669 21 11.07C21.1821 12.829 20.842 14.6026 20.0221 16.1695C19.2022 17.7363 17.9389 19.0269 16.39 19.88C15.3288 20.4938 14.1495 20.8755 12.93 21C12.62 21 12.3 21 12 21Z"
                      fill="#A8C686"
                    />
                  </svg>
                </span>{" "}
                Eco Vision
              </p>
              <div className="card">
                <img src={picOne} />
              </div>
            </div>
            <div className="col-3 col-md-3 col-lg-3 d-flex flex-column">
              <p className="text text-two">
                <span>
                  <svg
                    width="25px"
                    height="25px"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.5 15.25C10.307 15.2353 10.1276 15.1455 9.99998 15L6.99998 12C6.93314 11.8601 6.91133 11.7029 6.93756 11.55C6.96379 11.3971 7.03676 11.2562 7.14643 11.1465C7.2561 11.0368 7.39707 10.9638 7.54993 10.9376C7.70279 10.9114 7.86003 10.9332 7.99998 11L10.47 13.47L19 5.00004C19.1399 4.9332 19.2972 4.91139 19.45 4.93762C19.6029 4.96385 19.7439 5.03682 19.8535 5.14649C19.9632 5.25616 20.0362 5.39713 20.0624 5.54999C20.0886 5.70286 20.0668 5.86009 20 6.00004L11 15C10.8724 15.1455 10.6929 15.2353 10.5 15.25Z"
                      fill="#A8C686"
                    />
                    <path
                      d="M12 21C10.3915 20.9974 8.813 20.5638 7.42891 19.7443C6.04481 18.9247 4.90566 17.7492 4.12999 16.34C3.54037 15.29 3.17596 14.1287 3.05999 12.93C2.87697 11.1721 3.2156 9.39921 4.03363 7.83249C4.85167 6.26578 6.1129 4.9746 7.65999 4.12003C8.71001 3.53041 9.87134 3.166 11.07 3.05003C12.2641 2.92157 13.4719 3.03725 14.62 3.39003C14.7224 3.4105 14.8195 3.45215 14.9049 3.51232C14.9903 3.57248 15.0622 3.64983 15.116 3.73941C15.1698 3.82898 15.2043 3.92881 15.2173 4.03249C15.2302 4.13616 15.2214 4.2414 15.1913 4.34146C15.1612 4.44152 15.1105 4.53419 15.0425 4.61352C14.9745 4.69286 14.8907 4.75712 14.7965 4.80217C14.7022 4.84723 14.5995 4.87209 14.4951 4.87516C14.3907 4.87824 14.2867 4.85946 14.19 4.82003C13.2186 4.52795 12.1987 4.43275 11.19 4.54003C10.193 4.64212 9.22694 4.94485 8.34999 5.43003C7.50512 5.89613 6.75813 6.52088 6.14999 7.27003C5.52385 8.03319 5.05628 8.91361 4.77467 9.85974C4.49307 10.8059 4.40308 11.7987 4.50999 12.78C4.61208 13.777 4.91482 14.7431 5.39999 15.62C5.86609 16.4649 6.49084 17.2119 7.23999 17.82C8.00315 18.4462 8.88357 18.9137 9.8297 19.1953C10.7758 19.4769 11.7686 19.5669 12.75 19.46C13.747 19.3579 14.713 19.0552 15.59 18.57C16.4349 18.1039 17.1818 17.4792 17.79 16.73C18.4161 15.9669 18.8837 15.0864 19.1653 14.1403C19.4469 13.1942 19.5369 12.2014 19.43 11.22C19.4201 11.1169 19.4307 11.0129 19.461 10.9139C19.4914 10.8149 19.5409 10.7228 19.6069 10.643C19.6728 10.5631 19.7538 10.497 19.8453 10.4485C19.9368 10.3999 20.0369 10.3699 20.14 10.36C20.2431 10.3502 20.3471 10.3607 20.4461 10.3911C20.5451 10.4214 20.6372 10.471 20.717 10.5369C20.7969 10.6028 20.863 10.6839 20.9115 10.7753C20.9601 10.8668 20.9901 10.9669 21 11.07C21.1821 12.829 20.842 14.6026 20.0221 16.1695C19.2022 17.7363 17.9389 19.0269 16.39 19.88C15.3288 20.4938 14.1495 20.8755 12.93 21C12.62 21 12.3 21 12 21Z"
                      fill="#A8C686"
                    />
                  </svg>
                </span>{" "}
                Green Path
              </p>
              <div className="card">
                <img src={plantSix} alt="plant-6.jpg" />
              </div>
            </div>
            <div className="col-3 col-md-3 col-lg-3 d-flex flex-column">
              <div className="card">
                <img src={pic} alt="pic.jpg" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
